// Client-side mirror of the screening-question rules (rebase is the authority).
export const MAX_QUESTIONS = 6
export const MAX_TEXT = 200

export function newQuestionId () {
  let hex = ''
  while (hex.length < 6) hex += Math.floor(Math.random() * 16).toString(16)
  return 'q_' + hex
}

export function newQuestion () {
  return { id: newQuestionId(), text: '', expected: 'yes', must: false }
}

export function normalizeText (text) {
  return String(text || '').replace(/\s+/g, ' ').trim()
}

// Same text, with one trailing "?" appended when none is present.
export function withQuestionMark (text) {
  const t = normalizeText(text)
  if (!t) return t
  return t.indexOf('?') === -1 ? t + '?' : t
}

// Returns { rows: [clean rows], errors: [msg|null per input row], valid }
export function validateQuestions (list) {
  const rows = []
  const errors = []
  const seen = {}
  const input = Array.isArray(list) ? list : []
  input.forEach(function (q) {
    const text = withQuestionMark(q && q.text)
    const expected = ['yes', 'no', 'any'].indexOf(q && q.expected) !== -1 ? q.expected : 'yes'
    let err = null
    if (!normalizeText(q && q.text)) err = 'יש למלא נוסח שאלה'
    else if (text.length > MAX_TEXT) err = 'עד ' + MAX_TEXT + ' תווים'
    else if (text.split('?').length - 1 !== 1) err = 'שאלה אחת בשורה: סימן שאלה אחד בלבד'
    else if (seen[text]) err = 'שאלה כפולה'
    if (!err) seen[text] = true
    errors.push(err)
    rows.push({ id: q.id, text: text, expected: expected, must: expected === 'any' ? false : !!q.must })
  })
  if (input.length > MAX_QUESTIONS) {
    for (let i = MAX_QUESTIONS; i < errors.length; i++) errors[i] = errors[i] || 'עד ' + MAX_QUESTIONS + ' שאלות'
  }
  return { rows: rows, errors: errors, valid: errors.every(function (e) { return !e }) }
}
